export default {
  data() {
    return {
      editorToolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6],
          },
        ],
        [
          {
            align: '',
          },
          {
            align: 'center',
          },
          {
            align: 'right',
          },
          {
            align: 'justify',
          },
        ],
        [
          'bold',
          'italic',
          'underline',
        ],
        [
          {
            list: 'ordered',
          },
          {
            list: 'bullet',
          },
        ],
        [
          {
            color: [],
          },
          {
            background: [],
          },
        ],
        [
          'image',
          'clean',
        ],
      ],
    };
  },
  methods: {
    handleImageAdded(file, editor, cursorLocation, resetUploader) {
      const formData = new FormData();
      formData.append('image', file);

      this.axios.post('templates/images', formData).then((response) => {
        editor.insertEmbed(cursorLocation, 'image', response.data);
        resetUploader();
      }).catch(() => {

      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/emailEditorToolbar.js